
export default function UserProfile() {
    return {
        id: 0,
        userUUID: '',
        firstName: '',
        lastName: '',
        email: '',
        dateOfBirth: '',
        phoneNumber: '',
        role: '',
        // Add other fields as needed
    };
}